import React from "react"
import { observer } from "mobx-react"
import { Col, Flex, Row } from "antd"

import crystal from "@src/app/assets/crystal-white.png"
import crystalRetina from "@src/app/assets/crystal-white@2x.png"
import sendCryptoCrystal from "@src/app/assets/send-crypto-crystal.png"
import sendCryptoCrystalRetina from "@src/app/assets/send-crypto-crystal@2x.png"
import uiStore from "@src/app/uiStore"
import { checkPartner } from "@src/shared/checkPartner"
import { useBreakpoint } from "@src/shared/hooks/useBreakpoints"
import css from "./index.module.css"

type Props = {
  children: React.ReactNode
}

export const AuthLayout = observer(({ children }: Props) => {
  const { isTransferioTheme } = uiStore()
  const { smallerThanLg } = useBreakpoint()
  const referral_link_id = new URLSearchParams(window.location.search).get("id")
  const isSendCrypto = checkPartner(referral_link_id)

  return (
    <Row
      align="middle"
      className={css.container}
      gutter={smallerThanLg ? 12 : 70}
      justify={isTransferioTheme || smallerThanLg ? "center" : "space-between"}
      style={{
        padding: smallerThanLg ? 4 : 12,
      }}
    >
      <Col span={smallerThanLg ? 24 : 14}>
        <Flex className={css.leftSide} justify="center">
          {children}
        </Flex>
      </Col>
      {!(isTransferioTheme || smallerThanLg) && (
        <Col span={10}>
          <Flex className={css.rightSide}>
            <img
              alt="crystal"
              className={css.crystal}
              src={isSendCrypto ? sendCryptoCrystal : crystal}
              srcSet={
                isSendCrypto
                  ? `${sendCryptoCrystalRetina} 2x`
                  : `${crystalRetina} 2x`
              }
            />
          </Flex>
        </Col>
      )}
    </Row>
  )
})
